import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { FilterComponent } from './filter.component';
import { SaveFilterModalComponent } from 'app/features/measurement/components/save-filter-modal/save-filter-modal.component';

@NgModule({
    declarations: [FilterComponent, SaveFilterModalComponent],
    imports: [SharedModule],
    exports: [FilterComponent, SaveFilterModalComponent]
})
export class FilterModule {}
